// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "bs-platform/lib/es6/list.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as Printf from "bs-platform/lib/es6/printf.js";
import * as $$String from "bs-platform/lib/es6/string.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Color$YourProjectName from "./color.bs.js";
import * as AppState$YourProjectName from "./appState.bs.js";

var beginTikz = "\\begin{tikzpicture}[baseline=0.5cm, x=0.5cm, y=0.5cm]";

var endTikz = "\\end{tikzpicture}";

function fromCoordinate(c) {
  return Curry._3(Printf.sprintf(/* Format */{
                  _0: {
                    TAG: /* String_literal */11,
                    _0: "\\coordinate (",
                    _1: {
                      TAG: /* String */2,
                      _0: /* No_padding */0,
                      _1: {
                        TAG: /* String_literal */11,
                        _0: ") at (",
                        _1: {
                          TAG: /* Float */8,
                          _0: /* Float_f */0,
                          _1: /* No_padding */0,
                          _2: /* No_precision */0,
                          _3: {
                            TAG: /* String_literal */11,
                            _0: ", ",
                            _1: {
                              TAG: /* Float */8,
                              _0: /* Float_f */0,
                              _1: /* No_padding */0,
                              _2: /* No_precision */0,
                              _3: {
                                TAG: /* String_literal */11,
                                _0: ");",
                                _1: /* End_of_format */0
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  _1: "\\coordinate (%s) at (%f, %f);"
                }), c.coordinate_id, c.x, c.y);
}

function fromDir(dir) {
  switch (dir) {
    case /* Above */0 :
        return "90";
    case /* Below */1 :
        return "-90";
    case /* Left */2 :
        return "180";
    case /* Right */3 :
        return "0";
    
  }
}

function fromDirs(d1, d2) {
  return Curry._2(Printf.sprintf(/* Format */{
                  _0: {
                    TAG: /* String_literal */11,
                    _0: "to[out=",
                    _1: {
                      TAG: /* String */2,
                      _0: /* No_padding */0,
                      _1: {
                        TAG: /* String_literal */11,
                        _0: ", in=",
                        _1: {
                          TAG: /* String */2,
                          _0: /* No_padding */0,
                          _1: {
                            TAG: /* Char_literal */12,
                            _0: /* "]" */93,
                            _1: /* End_of_format */0
                          }
                        }
                      }
                    }
                  },
                  _1: "to[out=%s, in=%s]"
                }), fromDir(d1), fromDir(d2));
}

function fromEdge$prime(e) {
  var match = e.curve;
  return [
          "(" + (e.scoord + ")"),
          match ? Curry._2(Printf.sprintf(/* Format */{
                      _0: {
                        TAG: /* Char_literal */12,
                        _0: /* " " */32,
                        _1: {
                          TAG: /* String */2,
                          _0: /* No_padding */0,
                          _1: {
                            TAG: /* String_literal */11,
                            _0: " (",
                            _1: {
                              TAG: /* String */2,
                              _0: /* No_padding */0,
                              _1: {
                                TAG: /* Char_literal */12,
                                _0: /* ")" */41,
                                _1: /* End_of_format */0
                              }
                            }
                          }
                        }
                      },
                      _1: " %s (%s)"
                    }), fromDirs(match._0, match._1), e.tcoord) : Curry._1(Printf.sprintf(/* Format */{
                      _0: {
                        TAG: /* String_literal */11,
                        _0: " -- (",
                        _1: {
                          TAG: /* String */2,
                          _0: /* No_padding */0,
                          _1: {
                            TAG: /* Char_literal */12,
                            _0: /* ")" */41,
                            _1: /* End_of_format */0
                          }
                        }
                      },
                      _1: " -- (%s)"
                    }), e.tcoord)
        ];
}

function fromEdge(e) {
  if (!e.draw) {
    return "";
  }
  var match = fromEdge$prime(e);
  return Curry._1(Printf.sprintf(/* Format */{
                  _0: {
                    TAG: /* String_literal */11,
                    _0: "\\draw ",
                    _1: {
                      TAG: /* String */2,
                      _0: /* No_padding */0,
                      _1: {
                        TAG: /* Char_literal */12,
                        _0: /* ";" */59,
                        _1: /* End_of_format */0
                      }
                    }
                  },
                  _1: "\\draw %s;"
                }), match[0] + match[1]);
}

function fromFill(state, fill) {
  var func = function (prevCoord, edges) {
    if (!edges) {
      return "-- cycle";
    }
    var es = edges.tl;
    var e = edges.hd;
    if (prevCoord === e.scoord) {
      var match = fromEdge$prime(e);
      return match[1] + func(e.tcoord, es);
    }
    var match$1 = fromEdge$prime(e);
    return " -- " + (match$1[0] + (match$1[1] + func(e.tcoord, es)));
  };
  var match = AppState$YourProjectName.findEdges(state.edges, fill.edges);
  if (match === undefined) {
    return "";
  }
  if (!match) {
    return "";
  }
  var head = match.hd;
  var match$1 = fromEdge$prime(head);
  return Curry._3(Printf.sprintf(/* Format */{
                  _0: {
                    TAG: /* String_literal */11,
                    _0: "\\fill[",
                    _1: {
                      TAG: /* String */2,
                      _0: /* No_padding */0,
                      _1: {
                        TAG: /* String_literal */11,
                        _0: "] ",
                        _1: {
                          TAG: /* String */2,
                          _0: /* No_padding */0,
                          _1: {
                            TAG: /* Char_literal */12,
                            _0: /* " " */32,
                            _1: {
                              TAG: /* String */2,
                              _0: /* No_padding */0,
                              _1: {
                                TAG: /* Char_literal */12,
                                _0: /* ";" */59,
                                _1: /* End_of_format */0
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  _1: "\\fill[%s] %s %s;"
                }), Color$YourProjectName.toString(fill.color), match$1[0] + match$1[1], func(head.tcoord, match.tl));
}

function Tikz(Props) {
  var state = Props.state;
  var coordinatesTikz = List.map(fromCoordinate, state.coordinates);
  var fillsTikz = List.map((function (param) {
          return fromFill(state, param);
        }), state.fills);
  var edgesTikz = List.filter(function (str) {
          return str !== "";
        })(List.map(fromEdge, state.edges));
  var tikz = $$String.concat("\n", Pervasives.$at({
            hd: beginTikz,
            tl: /* [] */0
          }, Pervasives.$at(coordinatesTikz, Pervasives.$at(fillsTikz, Pervasives.$at(edgesTikz, {
                        hd: endTikz,
                        tl: /* [] */0
                      })))));
  return React.createElement("div", {
              id: ""
            }, React.createElement("textarea", {
                  className: "tikz",
                  value: tikz,
                  onChange: (function (param) {
                      
                    })
                }));
}

var make = Tikz;

export {
  beginTikz ,
  endTikz ,
  fromCoordinate ,
  fromDir ,
  fromDirs ,
  fromEdge$prime ,
  fromEdge ,
  fromFill ,
  make ,
  
}
/* react Not a pure module */
